import { useContext } from 'react';

import { BookmarkContext } from '../../context';
import { addBookmark, removeBookmark } from '../../utils';

export type UseIsBookmarkedResult = {
  isBookmarked: boolean;
  toggleBookmark: (estateId?: string | Event) => void;
};

export const useIsBookmarked = (estateID?: string): UseIsBookmarkedResult => {
  const { bookmarks, loadBookmarks } = useContext(BookmarkContext);
  const isBookmarked = bookmarks.findIndex((bookmark) => bookmark.estateId === estateID) >= 0;

  const handleBookmark = async (givenEstateId: string) => {
    if (!isBookmarked) {
      addBookmark(givenEstateId);
    } else {
      removeBookmark(givenEstateId);
    }
    loadBookmarks();
  };

  const bookmarkItem = async (givenEstateId?: string | Event) => {
    await handleBookmark(typeof givenEstateId === 'string' ? givenEstateId : estateID);
  };

  return { isBookmarked, toggleBookmark: bookmarkItem };
};
